// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__pILdy","active":"NavItem_active__1MiRe","selected":"NavItem_selected__2hKxm"};